var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1 53.85C25.5 54.575 27.925 55 30.5 55C37.1304 55 43.4893 52.3661 48.1777 47.6777C52.8661 42.9893 55.5 36.6304 55.5 30C55.5 26.717 54.8534 23.4661 53.597 20.4329C52.3406 17.3998 50.4991 14.6438 48.1777 12.3223C45.8562 10.0009 43.1002 8.15938 40.0671 6.90301C37.0339 5.64664 33.783 5 30.5 5C27.217 5 23.9661 5.64664 20.9329 6.90301C17.8998 8.15938 15.1438 10.0009 12.8223 12.3223C8.13392 17.0107 5.5 23.3696 5.5 30C5.5 40.625 12.175 49.75 21.6 53.35C21.375 51.4 21.15 48.175 21.6 45.95L24.475 33.6C24.475 33.6 23.75 32.15 23.75 29.85C23.75 26.4 25.9 23.825 28.35 23.825C30.5 23.825 31.5 25.4 31.5 27.425C31.5 29.575 30.075 32.65 29.35 35.6C28.925 38.05 30.65 40.2 33.15 40.2C37.6 40.2 41.05 35.45 41.05 28.75C41.05 22.75 36.75 18.65 30.575 18.65C23.525 18.65 19.375 23.9 19.375 29.425C19.375 31.575 20.075 33.75 21.225 35.175C21.45 35.325 21.45 35.525 21.375 35.9L20.65 38.625C20.65 39.05 20.375 39.2 19.95 38.9C16.75 37.5 14.9 32.95 14.9 29.275C14.9 21.375 20.5 14.2 31.3 14.2C39.9 14.2 46.6 20.375 46.6 28.575C46.6 37.175 41.275 44.075 33.65 44.075C31.225 44.075 28.85 42.775 28 41.25L26.325 47.175C25.75 49.325 24.175 52.2 23.1 53.925V53.85Z",
    fill: "#80FF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "homepage/static/media/pinterest.a0b04ae1e73434802749c99dd2621af8.svg";
export { ForwardRef as ReactComponent };